import { CREDIT_NOTE_BILL_BASE_RETURN_REQUEST, CREATE_CREDIT_NOTE_BILL_BASE_RETURN, GET_CREDIT_NOTE_BILL_BASE_RETURNS, UPDATE_CREDIT_NOTE_BILL_BASE_RETURN, DELETE_CREDIT_NOTE_BILL_BASE_RETURN, CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE, GET_CREDIT_NOTE_BILL_BASE_RETURNS_PAGE, CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS } from '../types';

const initialState = {
  creditNoteBillBaseReturns: [],
  creditNoteBillBaseReturnsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const creditNoteBillBaseReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_NOTE_BILL_BASE_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_CREDIT_NOTE_BILL_BASE_RETURNS: {
      return {
        ...state,
        creditNoteBillBaseReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_CREDIT_NOTE_BILL_BASE_RETURNS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          creditNoteBillBaseReturnsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
    case CREATE_CREDIT_NOTE_BILL_BASE_RETURN:
      return {
        ...state,
        creditNoteBillBaseReturns: [action.payload, ...state.creditNoteBillBaseReturns],
        loading: false,
        error: null
      };
    case UPDATE_CREDIT_NOTE_BILL_BASE_RETURN:
      const creditNoteBillBaseReturnsData = state.creditNoteBillBaseReturns.slice(0);
      const uIndex = creditNoteBillBaseReturnsData.findIndex((data) => data.id === action.payload.id);
      creditNoteBillBaseReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        creditNoteBillBaseReturns: [ ...creditNoteBillBaseReturnsData ],
        loading: false,
        error: null
      };
    case DELETE_CREDIT_NOTE_BILL_BASE_RETURN:
      const creditNoteBillBaseReturns = state.creditNoteBillBaseReturns?.slice(0);
      const index = creditNoteBillBaseReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        creditNoteBillBaseReturns.splice(index, 1);
      }
      return {
        ...state,
        creditNoteBillBaseReturns: [...creditNoteBillBaseReturns],
        loading: false,
        error: null
      }
    case CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case CREDIT_NOTE_BILL_BASE_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default creditNoteBillBaseReturnReducer;